"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionList = SectionList;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_use_measure_1 = __importDefault(require("react-use-measure"));
const react_window_1 = require("react-window");
const __1 = require("..");
const ITEM_GAP = 5;
function SectionList({ sections, render, itemSize = 30, getListRefCallback, headerStylingCallback, }) {
    const flatIndex = react_1.default.useMemo(() => sections.reduce((flat, nextSection) => [
        ...flat,
        nextSection.name,
        ...nextSection.values,
    ], []), [sections]);
    const ref = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        if (ref.current) {
            ref.current.resetAfterIndex(0);
            if (getListRefCallback) {
                getListRefCallback(ref);
            }
        }
    }, [sections, getListRefCallback]);
    const [resizeRef, { height, width }] = (0, react_use_measure_1.default)();
    return (react_1.default.createElement("div", { ref: resizeRef, style: {
            width: "100%",
            flex: "1 1 0",
            overflow: "hidden",
        } },
        react_1.default.createElement(react_window_1.VariableSizeList, { ref: ref, height: height, width: width, style: { willChange: "auto", scrollbarWidth: "thin" }, itemCount: flatIndex.length, itemSize: (index) => (typeof flatIndex[index] === "string" ? 20 : itemSize) + ITEM_GAP }, ({ index, style }) => {
            const item = flatIndex[index];
            const isSectionLabel = typeof item === "string";
            const headerStyling = headerStylingCallback
                ? headerStylingCallback(item)
                : undefined;
            return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                react_1.default.createElement("div", { style: {
                        ...style,
                        paddingBottom: ITEM_GAP,
                    } },
                    react_1.default.createElement("div", { style: {
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "nowrap",
                        } }, isSectionLabel ? (react_1.default.createElement(__1.Text, { style: {
                            flex: "1 1 auto",
                            ...headerStyling,
                        } }, item)) : (render(item))))));
        })));
}
//# sourceMappingURL=index.js.map